import { proxy, useSnapshot } from 'valtio';
import { useCallback } from 'react';
import throttle from 'lodash.throttle';
import { isNil } from 'ramda';
import { O } from '../lib/EffectExports';
const errorStore = proxy({
    state: O.none(),
});
const setError = (error) => {
    errorStore.state = O.fromNullable(error);
};
const setErrorImmediate = (error) => setError({
    message: 'unknown error with cause',
    originalError: error,
    code: 'unknown',
});
const setErrorThrottled = throttle(setErrorImmediate, 10000, {
    leading: false,
});
export const useErrorState = () => {
    const errorState = useSnapshot(errorStore);
    return {
        errorState: errorState.state,
        setErrorState: setError,
    };
};
export const useSetError = () => {
    return useCallback((error) => {
        if (isNil(error)) {
            setError(undefined);
            setErrorThrottled.cancel();
        }
        else {
            setErrorThrottled(error);
        }
    }, []);
};
//# sourceMappingURL=useErrorState.js.map